<template>
  <div>
    <!-- 搜索栏 -->
    <el-row :gutter="20" class="search-row">
      <el-col :span="6">
        <el-input
            v-model="searchForm.userName"
            placeholder="输入学员用户名"
            clearable
        ></el-input>
      </el-col>
      <el-col :span="6">
        <el-input
            v-model="searchForm.name"
            placeholder="输入学员姓名"
            clearable
        ></el-input>
      </el-col>
      <el-col :span="6">
        <el-select
            v-model="searchForm.organizationID"
            placeholder="选择所属机构"
            clearable
            style="width: 100%"
        >
          <el-option
              v-for="organization in organizations"
              :key="organization.organizationID"
              :label="organization.orgName"
              :value="organization.organizationID"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="fetchData">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
        <el-button type="success" @click="openAddDialog">添加学员</el-button>
      </el-col>
    </el-row>

    <!-- 学员信息表格 -->
    <el-table :data="studentList" style="width: 100%" stripe>
      <el-table-column label="用户名" prop="userName" :min-width="120"></el-table-column>
      <el-table-column label="姓名" prop="name" :min-width="120"></el-table-column>
      <el-table-column label="邮箱" prop="emaiAddress" :min-width="200"></el-table-column>
      <el-table-column label="电话" prop="phone" :min-width="150"></el-table-column>
      <el-table-column label="所属机构" prop="organizationID" :min-width="150"></el-table-column>
      <el-table-column label="创建时间" prop="createDate" :min-width="200"></el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" :min-width="200">
        <template v-slot="{ row }">
          <el-button size="small" type="warning" @click="openEditDialog(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="deleteStudent(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
        v-if="totalCount > 0"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        layout="total, prev, pager, next, jumper"
        @current-change="handlePageChange"
    ></el-pagination>

    <!-- 编辑学员信息弹窗 -->
    <el-dialog :title="editMode ? '编辑学员' : '新增学员'" v-model="dialogVisible">
      <el-form :model="dialogForm" label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="dialogForm.userName" :disabled="editMode"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="dialogForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="dialogForm.name"></el-input>
        </el-form-item>
        <el-form-item label="机构">
          <el-select v-model="dialogForm.organizationID" placeholder="请选择机构">
            <el-option
                v-for="organization in organizations"
                :key="organization.organizationID"
                :label="organization.orgName"
                :value="organization.organizationID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="dialogForm.emaiAddress"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="dialogForm.phone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitDialog">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      organizations: [],
      searchForm: {
        userName: "",
        name: "",
        organizationID: null,
      },
      studentList: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      editMode: false,
      dialogForm: {
        userName: "",
        name: "",
        password: "",
        organizationID: null,
        emaiAddress: "",
        phone: "",
      },
    };
  },
  methods: {
    fetchData() {
      const params = {
        UserName: this.searchForm.userName,
        name: this.searchForm.name,
        Role: "学员",
        OrganizationID: this.searchForm.organizationID,
        page: this.currentPage,
        size: this.pageSize,
      };

      axios
          .get("/Manage/users", { params })
          .then((response) => {
            const { data } = response;
            this.studentList = data.data;
            this.totalCount = data.total;
          })
          .catch(() => {
            ElMessage.error("获取学员信息失败");
          });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },
    resetSearch() {
      this.searchForm = {
        userName: "",
        name: "",
        organizationID: null,
      };
      this.fetchData();
    },
    openEditDialog(row) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dialogForm = { ...row };
    },
    openAddDialog() {
      this.dialogVisible = true;
      this.editMode = false;
      this.dialogForm = {
        userName: "",
        name: "",
        password: "",
        organizationID: null,
        emaiAddress: "",
        phone: "",
      };
    },
    submitDialog() {
      this.dialogForm.Role = "学员";
      const api = this.editMode ? "/Manage/edituser" : "/Manage/adduser";
      axios
          .post(api, this.dialogForm,{params:{OrganizationID:   this.dialogForm.organizationID

            }})
          .then(() => {
            ElMessage.success(this.editMode ? "编辑成功" : "新增成功");
            this.dialogVisible = false;
            this.fetchData();
          })
          .catch(() => {
            ElMessage.error(this.editMode ? "编辑失败" : "新增失败");
          });
    },
    deleteStudent(row) {
      axios
          .post("/student/delete", {userID: row.userID})
          .then(() => {
            ElMessage.success("删除成功");
            this.fetchData();
          })
          .catch(() => {
            ElMessage.error("删除失败");
          });
    },
  },
  created() {
    this.fetchData();
    axios
        .get("/organization/orglist")
        .then((res) => {
          this.organizations = res.data.data;
        })
        .catch(() => {
          ElMessage.error("获取机构列表失败");
        });
  },
};
</script>

<style scoped>
.search-row {
  margin-bottom: 20px;
}
</style>
